import React, { Dispatch, MutableRefObject, SetStateAction, useRef } from 'react';
import { CashoutResponseApiWithTimer, setSelectedBet } from 'features/dashboard/myBets/myBetSlice';
import { MieScommesseTableRow, TableFieldProps } from 'components/mieScommesseTableRow/MieScommesseTableRow';
import { RootState, useAppDispatch } from 'lib/centralStore';
import { populateItemIppicaRow, populateItemMieScommesseRow } from 'utility/dashboard/functions';

import { DatoCmsMyBetsPage } from 'lib/datoCms/queries/getMyBetsPage';
import { MieScommesseTableRowMobile } from 'components/mieScommesseTableRowMobile';
import { MyBet } from 'types/dashboard/myBet';
import { NoResult } from 'components/noResult';
import { PollingCashoutResponseApi } from 'lib/api/pollingCashoutResponseApi';
import { ScommesseResponseApiItem } from 'lib/api/scommesseResponseApi';
import { breakpoint } from 'utility/constant';
import styles from './TableMovimentiMyBet.module.scss';
import { useGetLabelsByKeys } from 'hooks/useLingUI';
import { useRouter } from 'next/router';
import { useTypedSelector } from 'lib/centralStore';
import useWindowSize, { enComparer } from 'hooks/useWindowSize';

export type TableMovimentiMyBetProps = {
  myBetPage?: DatoCmsMyBetsPage;
  // enabledCashOutFilter: boolean;
  verticale: string;
  selectedStatusTab: string;
  pageNumber: number;
  list?: {
    totalPages: number | null;
    items: ScommesseResponseApiItem[];
  };
  isInColumn?: boolean;
  labels: {
    cashOut: string;
    seeNext: string;
  };
  cashOutEnabled?: boolean;
  // myBetsHref?: string;
  cashoutResponse?: PollingCashoutResponseApi;
  idsRealTimeCashoutRef: MutableRefObject<string[]>;
  setPageNumber: Dispatch<SetStateAction<number>>;
  handleSelect?: Dispatch<SetStateAction<MyBet | undefined>>;
  refetchApiBets?: () => void;
  // setEnabledCashOutFilter: Dispatch<SetStateAction<boolean>>;
};

export const TableMovimentiMyBet = ({
  myBetPage,
  list,
  labels,
  verticale,
  pageNumber,
  isInColumn,
  //  myBetsHref,
  cashOutEnabled,
  cashoutResponse,
  selectedStatusTab,
  //  enabledCashOutFilter,
  idsRealTimeCashoutRef,
  handleSelect,
  setPageNumber,
  refetchApiBets,
}: //  setEnabledCashOutFilter,
TableMovimentiMyBetProps) => {
  const dispatch = useAppDispatch();

  const { doCheck } = useWindowSize();
  const [isMobile] = doCheck([{ comparer: enComparer.less, size: breakpoint.sm }]);

  const { pathname } = useRouter();
  const isNotDashboardScommesse = pathname !== '/dashboard/le-mie-scommesse';

  const { blockedIdsRealTimeCashout } = useTypedSelector(({ myBets }) => myBets);
  const blockedIdsRealTimeCashoutRef = useRef<CashoutResponseApiWithTimer[]>([]);

  const [labelIppica, labelCashOut, labelNessunaScommessa] = useGetLabelsByKeys([
    'ippica',
    'cashout',
    'nessuna-scommessa',
  ]);
  const [
    labelSistema,
    labelMultipla,
    labelImportoGiocato,
    labelQuotaTotale,
    labelPossibileVincita,
    labelEventi,
    labelEsiti,
    labelVerificaCashout,
    labelStato,
    labelVincita,
    labelEmesso,
    labelSingola,
    labelConfermaCashout,
  ] = useGetLabelsByKeys([
    'sistema',
    'multipla',
    'importo-giocato',
    'quota-totale',
    'possibile-vincita',
    'eventi',
    'esiti',
    'verifica-cashout',
    'stato',
    'vincita',
    'emesso',
    'singola',
    'conferma-cashout',
  ]);

  const goToDetail = (item: ScommesseResponseApiItem) => {
    if (handleSelect) handleSelect({ ...item, verticale: verticale });
    else if (item) dispatch(setSelectedBet({ ...item, verticale: verticale }));
  };

  const labelsItem = {
    labelSistema,
    labelMultipla,
    labelImportoGiocato,
    labelQuotaTotale,
    labelPossibileVincita,
    labelEventi,
    labelEsiti,
    labelVerificaCashout,
    labelStato,
    labelVincita,
    labelEmesso,
    labelSingola,
    labelConfermaCashout,
  };

  return (
    <React.Fragment>
      <div className={cashOutEnabled ? styles.container : undefined}>
        {list?.items?.map((item, index) => {
          let data: TableFieldProps[] = [];
          // if (verticale === labelIppica) {
          //   data = populateItemIppicaRow(item, labelsItem);
          // } else {
          // if you need to pass dispatch, this should be a redux action
          data = populateItemMieScommesseRow({
            item,
            labels: labelsItem,
            isMobile,
            isInColumn,
            labelCashOut,
            cashoutResponse,
            selectedStatusTab,
            idsRealTimeCashoutRef,
            isNotDashboardScommesse,
            blockedIdsRealTimeCashout,
            blockedIdsRealTimeCashoutRef,
            dispatch,
            refetchApiBets,
          });
          //}
          return isMobile || isInColumn ? (
            <MieScommesseTableRowMobile key={index} columns={data} onClick={() => goToDetail(item)} />
          ) : (
            <MieScommesseTableRow key={index} columns={data} onClick={() => goToDetail(item)} />
          );
        })}
      </div>
      {list?.items && list?.items.length === 0 && (
        <NoResult
          noMargin
          className={styles.noResult}
          label={myBetPage ? myBetPage.labelNessunRisultato : labelNessunaScommessa}
        />
      )}
      {list && list.totalPages !== null && pageNumber < list.totalPages && (
        <div className={`${styles.buttonContainer} ${isInColumn ? styles.mobileButton : ''}`}>
          <button
            type="button"
            className={styles.button}
            disabled={!list || !list.totalPages || pageNumber >= list.totalPages}
            onClick={() => {
              setPageNumber(pageNumber + 1);
            }}
          >
            {labels.seeNext}
          </button>
        </div>
      )}
    </React.Fragment>
  );
};